import React, { useEffect, createRef } from 'react';

import Scrollbar from '../../scrollbars';
import { Tooltip } from '../../tooltip';
import { Styled } from '../styled';
import { useTooltips } from './hooks';
import { ListContent } from './list-content';
import { getItemsHeight } from './utils';

const DropdownListComponent = (props) => {
  const {
    filteredElements,
    tooltips,
    onClick,
    borderRadius,
    activeElements,
    activeElementIndex,
    maxItemsAmount,
    children,
    forceShowChildren,
    optionRenderer,
  } = props;
  const menuHeight = getItemsHeight(
    filteredElements.length,
    !!forceShowChildren,
    maxItemsAmount,
  );
  const itemsHeight = getItemsHeight(
    filteredElements.length,
    !!forceShowChildren,
    forceShowChildren ? maxItemsAmount-1 : maxItemsAmount,
  );
  const firstActiveElementIndex =
    activeElements &&
    filteredElements.findIndex((el) => el === activeElements[0]);
  const scrollRef = createRef();
  const [tooltip, setTooltip, removeTooltip] = useTooltips(tooltips);
  useEffect(() => {
    firstActiveElementIndex !== undefined &&
      scrollRef.current.scrollbarRef.current.scrollTop(
        firstActiveElementIndex * Styled.ITEM_HEIGHT
      );
  }, []);

  return (
    <Styled.DropDownMenuContainer
      height={menuHeight}
      borderRadius={borderRadius}
    >
      <Styled.ItemsContainer height={itemsHeight}>
        <Scrollbar autoHide={false} ref={scrollRef}>
          <ListContent
            filteredElements={filteredElements}
            activeElementIndex={activeElementIndex}
            borderRadius={borderRadius}
            setTooltip={setTooltip}
            removeTooltip={removeTooltip}
            onClick={onClick}
            optionRenderer={optionRenderer}
          />
        </Scrollbar>
      </Styled.ItemsContainer>
      {forceShowChildren ? children : null}
      {tooltip && (
        <Tooltip
          position={tooltip.position}
          targetTop={tooltip.targetElement.top}
          targetBottom={tooltip.targetElement.bottom}
          targetLeft={tooltip.targetElement.left}
          targetRight={tooltip.targetElement.right}
          targetWidth={tooltip.targetElement.width}
          targetHeight={tooltip.targetElement.height}
          text={tooltip.text}
          speed={tooltip.speed}
          description={tooltip.description}
        />
      )}
    </Styled.DropDownMenuContainer>
  );
};

export const DropdownList = React.memo(DropdownListComponent);
